import {
  Typography,
  Container,
  Grid,
  Box,
  FormControl,
  MenuItem,
  Select,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import { allColors } from "../../constants";
import { icons, images } from "../../assets";
import { Phone as PhoneIcon } from "@mui/icons-material";
import GlobalButton from "./../../components/globalButton/index";
import TextInput from "./../../components/textInput/index";
import { callBackRequest } from "../../services/callBackApiFn";
import Swal from "sweetalert2";

const DEPATMENT = [
  "Referral",
  "Customer service",
  "Sales",
  "Provisioning",
  "Broadband",
  "Faults",
  "Card Payments",
];

const ContactForm = ({ openChatBoxRef }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    phone: "",
    accountNumber: "",
    department: "",
    message: "",
  });

  const [inputErrors, setInputErrors] = useState({
    name: "",
    email: "",
    phone: "",
    accountNumber: "",
    department: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputValues({ ...inputValues, [name]: value });
    setInputErrors({ ...inputErrors, [name]: "" });
  };

  const handleSendCallBackRequest = async () => {
    let errors = {};
    let hasError = false;

    const KEYS = {
      name: "Name",
      email: "Email",
      phone: "Phone",
      accountNumber: "Account Number",
      department: "Department",
      message: "Message",
    };

    Object.keys(inputValues).forEach((key) => {
      if (!inputValues[key].trim()) {
        errors[key] = `${KEYS[key]} is required`;
        hasError = true;
      }
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (inputValues.email && !emailRegex.test(inputValues.email)) {
      errors.email = "Invalid email format";
      hasError = true;
    }

    if (hasError) {
      setInputErrors(errors);
      return;
    }

    try {
      setIsLoading(true);
      const response = await callBackRequest(inputValues);
      if (response.data.status === "success") {
        Swal.fire({
          title: "Success!",
          text: "Your callback request has been sent successfully.",
          icon: "success",
          confirmButtonColor: "#0073e6",
          confirmButtonText: "OK",
        });
        setInputValues({
          name: "",
          email: "",
          phone: "",
          accountNumber: "",
          department: "",
          message: "",
        });
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error?.message || "An unexpected error occurred.",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
      }}
      id="contact-us"
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "30px", sm: "40px", md: "50px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          fontFamily: "Raleway",
        }}
      >
        Trust. Connect.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "14px", md: "20px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          margin: "15px 0 30px",
          fontFamily: "Raleway",
        }}
      >
        Have a question or ready to switch? Our experts are here to help
      </Typography>

      <Grid container spacing={3.5} justifyContent={"center"}>
        <Grid item xs={12} sm={6} md={4.5}>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: { xs: "28px 20px", sm: "70px 20px" },
              textAlign: "center",
            }}
          >
            <a
              href="tel:02076299888"
              style={{ margin: "8px 0", textDecoration: "none" }}
            >
              <PhoneIcon
                sx={{
                  color: allColors.blueCrayola,
                  height: "50px",
                  width: "50px",
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "22px" },
                  color: allColors.jetBlack,
                  fontWeight: "600",
                  marginTop: "6px",
                  fontFamily: "Raleway",
                }}
              >
                Call us
              </Typography>
            </a>

            {/* <Typography
                sx={{
                  fontSize: { xs: "20px", sm: "25px", md: "33px" },
                  color: allColors.blueCrayola,
                  fontWeight: "400",
                  fontFamily: "Raleway",
                }}
              >
                0845 561 2525
              </Typography> */}
            <Typography
              sx={{
                fontSize: "14px",
                color: allColors.philippineGray,
                fontWeight: "400",
                fontFamily: "Raleway",
              }}
            >
              Mon - Fri 9:00am - 6:00pm
            </Typography>
          </Box>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: { xs: "28px 20px", sm: "60px 20px" },
              textAlign: "center",
              marginTop: "25px",
            }}
          >
            <img
              src={icons.circleChatIcon}
              style={{ width: "50px", height: "50px" }}
            />
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "22px" },
                color: allColors.jetBlack,
                fontWeight: "600",
                marginTop: "6px",
                fontFamily: "Raleway",
              }}
            >
              Chat
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "18px" },
                color: allColors.blueCrayola,
                fontWeight: "400",
                margin: "8px 0",
                fontFamily: "Raleway",
                cursor: "pointer",
              }}
              onClick={() => {
                openChatBoxRef.current.openDialog();
              }}
            >
              Click to start
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: allColors.philippineGray,
                fontWeight: "400",
                fontFamily: "Raleway",
              }}
            >
              Mon - Fri 9:00am - 6:00pm
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4.5}>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: "20px",
              textAlign: "center",
            }}
          >
            <img
              src={icons.circleTimerIcon}
              style={{ width: "50px", height: "50px" }}
            />
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "22px" },
                color: allColors.jetBlack,
                fontWeight: "600",
                margin: "6px 0 15px",
                fontFamily: "Raleway",
              }}
            >
              Request a callback
            </Typography>

            <TextInput
              fullWidth
              placeholder={"Enter your name"}
              type={"text"}
              name={"name"}
              value={inputValues.name}
              onChange={handleInputChange}
              inputError={!!inputErrors.name}
              helperText={inputErrors.name}
            />
            <Box sx={{ margin: "8px 0" }}>
              <TextInput
                fullWidth
                placeholder={"Enter your email"}
                type={"email"}
                name={"email"}
                value={inputValues.email}
                onChange={handleInputChange}
                inputError={!!inputErrors.email}
                helperText={inputErrors.email}
              />
            </Box>
            <TextInput
              type={"number"}
              fullWidth
              placeholder={"Enter your phone number"}
              name={"phone"}
              value={inputValues.phone}
              onChange={handleInputChange}
              inputError={!!inputErrors.phone}
              helperText={inputErrors.phone}
            />
            <Box sx={{ margin: "8px 0" }}>
              <TextInput
                type={"text"}
                fullWidth
                placeholder={"Enter your account number"}
                name={"accountNumber"}
                value={inputValues.accountNumber}
                onChange={handleInputChange}
                inputError={!!inputErrors.accountNumber}
                helperText={inputErrors.accountNumber}
              />
            </Box>
            <Box sx={{ margin: "8px 0" }}>
              <FormControl
                error={!!inputErrors.department}
                fullWidth
                sx={{
                  "&.MuiFormControl-root .MuiFormLabel-root": {
                    marginLeft: "15px",
                    color: allColors.darkGray,
                    fontSize: "12px",
                  },
                  "& .MuiSelect-outlined": {
                    padding: "13px 16px",
                  },
                  "& .MuiInputBase-root": {
                    borderRadius: "15px",
                    fontSize: "12px",
                    background: "transparent",
                    color: allColors.black,
                  },

                  "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${allColors.silverSand} !important`,
                  },
                }}
              >
                <Select
                  displayEmpty
                  value={inputValues.department}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left", color: "#a6a6a6" }}
                  name="department"
                >
                  <MenuItem value={""}>Select Department</MenuItem>

                  {DEPATMENT.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
                {inputErrors.department && (
                  <FormHelperText
                    sx={{
                      color: allColors.red,
                      fontSize: "12px",
                    }}
                  >
                    {inputErrors.department}
                  </FormHelperText>
                )}
              </FormControl>
            </Box>

            <TextInput
              fullWidth
              placeholder={"Enter your message"}
              isMultiline
              minRows={4}
              name={"message"}
              onChange={handleInputChange}
              value={inputValues.message}
              inputError={!!inputErrors.message}
              helperText={inputErrors.message}
            />

            <Box>
              <GlobalButton
                title={"Submit"}
                handleClickBtn={handleSendCallBackRequest}
                startIcon={isLoading ? <CircularProgress /> : null}
                disabled={isLoading}
                style={{
                  background: allColors.jasmine,
                  color: allColors.jetBlack,
                  borderRadius: "10px",
                  fontSize: "14px",
                  padding: "6px 30px",
                  marginTop: "15px",
                  fontWeight: "700",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactForm;
